import { useOutlet } from 'react-router-dom'

import styled from 'styled-components'

const HomeRouteLayout = () => {
    const outlet = useOutlet()

    return (
        <StyledHomeRoot>
            <StyledOutletWrapper>{outlet}</StyledOutletWrapper>
        </StyledHomeRoot>
    )
}

export default HomeRouteLayout

export const StyledLoginWrapper = styled.div`
    position: fixed;
    top: 20px;
    left: 50%;
    transform: translateX(-50%);

    display: flex;
    flex-direction: column;

    gap: 20px;
`

const StyledHomeRoot = styled.div`
    width: 100%;
    height: 100%;

    overflow: auto;
`
const StyledOutletWrapper = styled.div`
    width: 100%;
    height: 100%;

    max-width: 1110px;

    margin: 0 auto;

    padding-top: 20px;
`
